exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-active .button-container {\n  display: flex;\n}\n.edit-active .button-container .clone {\n  margin-left: 5px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/pages/grid-cell/styles.css
// module id = 1788
// module chunks = 29